export const Arrow = () => {
  return (
    <svg
      width='51'
      height='51'
      viewBox='0 0 51 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_14562_263627)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M31.5726 25.4375H21.6483L25.5126 29.3C25.8783 29.6656 25.8783 30.2657 25.5126 30.6313C25.1461 30.9969 24.5526 30.9969 24.1861 30.6313L18.8826 25.325C18.6586 25.1 18.5882 24.7906 18.6398 24.5C18.5882 24.2094 18.6586 23.9 18.8826 23.675L24.1861 18.3687C24.5526 18.0031 25.1461 18.0031 25.5126 18.3687C25.8783 18.7437 25.8783 19.3344 25.5126 19.7L21.6483 23.5625H31.5726C32.0901 23.5625 32.5101 23.9844 32.5101 24.5C32.5101 25.0156 32.0901 25.4375 31.5726 25.4375ZM25.0101 9.5C16.7264 9.5 10.0101 16.2125 10.0101 24.5C10.0101 32.7875 16.7264 39.5 25.0101 39.5C33.2939 39.5 40.0101 32.7875 40.0101 24.5C40.0101 16.2125 33.2939 9.5 25.0101 9.5Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_14562_263627'
          x='0.0101318'
          y='0.5'
          width='50'
          height='50'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_14562_263627'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_14562_263627'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}
